<template>
    <vx-card no-shadow title="Notification settings">
        <div class="w-full">
<!--          <a-card title="Reminders">-->
<!--            <p class="font-semibold">Pop-up</p>-->
<!--            <p class="text-sm text-justify">-->
<!--              Pop-up reminders use browser alerts to let you know about important upcoming events,-->
<!--              tasks, and more. Alerts may not be supported in outdated browsers.-->
<!--            </p>-->
<!--            <a-checkbox>-->
<!--              Skip all checks for outdated browsers-->
<!--            </a-checkbox>-->
<!--            <a-divider/>-->
<!--            <p class="font-semibold">Pop-up</p>-->
<!--            <p class="text-sm"><a href="#">Select and Verify email address </a> that receive notifications for your Cilo account</p>-->
<!--          </a-card>-->
          <a-card title="Notification" class="mt-5" :headStyle="{ 'paddingBottom': 0 }">
            <a-form :form="form" @submit.prevent="handleNotifications">
              <p slot="extra"> about <a href="#">in app notification</a> and <a href="#">mobile notification</a> </p>
              <div class="flex items-center">
                <div class="flex-grow">
                  <div class="space-x-2">
                    <feather-icon icon="CalendarIcon" theme="filled" svg-classes="w-4 h-4" class="inline-block"/>
                    <p class="font-bold text-lg inline-block">Calender</p>
                  </div>
                  <p class="font-semibold">New event added to Calender</p>
                  <p class="text-sm text-justify md:w-2/3">
                    Notify me when a new event is added on my calender by someone else
                  </p>
                </div>
                <div class="space-y-4">
                  <div class="flex justify-evenly items-center space-x-2">
                    <div class="">Email</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_new_calender_in_email',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>
                  </div>
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>in-app</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_new_calender_in_app',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>
                  </div>
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>Mobile</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_new_calender_in_mobile',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>

                  </div>
                </div>
              </div>
              <a-divider/>
              <div class="flex items-center">
                <div class="flex-grow">
                  <p class="font-semibold">Calender event updated</p>
                  <p class="text-sm text-justify md:w-2/3">
                    Notify me when a new event is updated by someone else
                  </p>
                </div>
                <div class="space-y-4">
                  <div class="flex justify-evenly items-center space-x-2">
                    <div class="">in-app</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_update_calender_in_app',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]" class="ml-3">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>

                  </div>
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>Mobile</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_update_calender_in_mobile',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]" class="ml-3">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>

                  </div>
                </div>
              </div>
              <a-divider/>
              <div class="flex items-center">
                <div class="flex-grow">
                  <p class="font-semibold">Calender event deleted</p>
                  <p class="text-sm text-justify md:w-2/3">
                    Notify me when a new event is deleted from my calender by someone else.
                  </p>
                </div>
                <div class="space-y-4">
                  <div class="flex justify-evenly items-center space-x-2">
                    <div class="">in-app</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_delete_calender_in_app',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]" class="ml-3">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>

                  </div>
                  <div class="flex justify-evenly items-center space-x-2">
                    <div class="">Mobile</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_delete_calender_in_mobile',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]" class="ml-3">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>
                  </div>
                </div>
              </div>
              <a-divider/>
<!--              <div class="flex items-center">-->
<!--                <div class="flex-grow">-->
<!--                  <div class="space-x-2">-->
<!--                    <feather-icon icon="UserIcon" theme="filled" svg-classes="w-4 h-4" class="inline-block"/>-->
<!--                    <p class="font-bold text-lg inline-block">Clio Connect</p>-->
<!--                  </div>-->
<!--                  <p class="font-semibold">Document uploaded through Clio Connect</p>-->
<!--                  <p class="text-sm text-justify md:w-2/3">-->
<!--                    Notify me when a document is document uploaded by a client or outside party through Clio Connect-->
<!--                  </p>-->
<!--                </div>-->
<!--                <div class="flex justify-evenly items-center space-x-2">-->
<!--                  <div class="">Email</div>-->
<!--                  <a-switch default-checked>-->
<!--                    <a-icon slot="checkedChildren" type="check" />-->
<!--                    <a-icon slot="unCheckedChildren" type="close" />-->
<!--                  </a-switch>-->
<!--                </div>-->
<!--              </div>-->
<!--              <a-divider/>-->
              <div class="flex items-center">
                <div class="flex-grow">
                  <div class="space-x-2">
                    <feather-icon icon="FolderIcon" theme="filled" svg-classes="w-4 h-4" class="inline-block"/>
                    <p class="font-bold text-lg inline-block">Documents</p>
                  </div>
                  <p class="font-semibold">Signed document received</p>
                  <p class="text-sm text-justify md:w-2/3">
                    Notify me when all signer have signed a document
                  </p>
                </div>
                <div class="space-y-4">
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>Email</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_document_in_email',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>

                  </div>
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>in-app</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_document_in_app',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>

                  </div>
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>Mobile</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_document_in_mobile',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>

                  </div>
                </div>
              </div>
              <a-divider/>
              <div class="flex items-center">
                <div class="flex-grow">
                  <div class="space-x-2">
                    <feather-icon icon="FolderIcon" theme="filled" svg-classes="w-4 h-4" class="inline-block"/>
                    <p class="font-bold text-lg inline-block">Matters</p>
                  </div>
                  <p class="font-semibold">Subscribed to matter notifications</p>
                  <p class="text-sm text-justify md:w-2/3">
                    Notify me when someone else subscribed me to notifications for a matter
                  </p>
                </div>
                <div class="space-y-4">
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>in-app</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_matter_Subscribed_in_app',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>

                  </div>
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>Mobile</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_matter_Subscribed_in_mobile',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>

                  </div>
                </div>
              </div>
              <a-divider/>
              <div class="flex items-center">
                <div class="flex-grow">
                  <p class="font-semibold">Matter status is updated</p>
                  <p class="text-sm text-justify md:w-2/3">
                    Notify me when the status is updated for a matter i am subscribed to.
                  </p>
                </div>
                <div class="space-y-4">
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>in-app</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_matter_status_in_app',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>

                  </div>
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>Mobile</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_matter_status_in_mobile',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>

                  </div>
                </div>
              </div>
              <a-divider/>
              <div class="flex items-center">
                <div class="flex-grow">
                  <p class="font-semibold">Matter deleted</p>
                  <p class="text-sm text-justify md:w-2/3">
                    Notify me when a matter that I am subscribed to is deleted.
                  </p>
                </div>
                <div class="space-y-4">
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>in-app</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_delete_matter_in_app',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>
                  </div>
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>Mobile</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_delete_matter_in_mobile',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>
                  </div>
                </div>
              </div>
              <a-divider/>
              <div class="flex items-center">
                <div class="flex-grow">
                  <p class="font-semibold">Matter budgets</p>
                  <p class="text-sm text-justify md:w-2/3">
                    Notify me when the budget is updated or crosses a set threshold for a matter I am subscribed to.
                  </p>
                </div>
                <div class="space-y-4">
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>Email</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_update_matter_in_email',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>
                  </div>
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>app</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_update_matter_in_app',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>
                  </div>
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>Mobile</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_update_matter_in_mobile',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>
                  </div>
                </div>
              </div>
              <a-divider/>
<!--              <div class="flex items-center">-->
<!--                <div class="flex-grow">-->
<!--                  <p class="font-semibold">Matter trust funds</p>-->
<!--                  <p class="text-sm text-justify md:w-2/3">-->
<!--                    Notify me when the trust balance is below the set threshold for a matter I am subscribed to.-->
<!--                  </p>-->
<!--                </div>-->
<!--                <div class="space-y-4">-->
<!--                  <div class="flex justify-evenly items-center space-x-2">-->
<!--                    <div>in-app</div>-->
<!--                    <a-switch default-checked>-->
<!--                      <a-icon slot="checkedChildren" type="check" />-->
<!--                      <a-icon slot="unCheckedChildren" type="close" />-->
<!--                    </a-switch>-->
<!--                  </div>-->
<!--                  <div class="flex justify-evenly items-center space-x-2">-->
<!--                    <div>Mobile</div>-->
<!--                    <a-switch default-checked>-->
<!--                      <a-icon slot="checkedChildren" type="check" />-->
<!--                      <a-icon slot="unCheckedChildren" type="close" />-->
<!--                    </a-switch>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <a-divider/>-->
              <div class="flex items-center">
                <div class="flex-grow">
                  <div class="space-x-2">
                    <feather-icon icon="Edit2Icon" theme="filled" svg-classes="w-4 h-4" class="inline-block"/>
                    <p class="font-bold text-lg inline-block">Notes</p>
                  </div>
                  <p class="font-semibold">Subscribed to matter notifications</p>
                  <p class="text-sm text-justify md:w-2/3">
                    Notify me when someone else subscribes me to notifications for a phone note
                  </p>
                </div>
                <div class="space-y-4">
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>in-app</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_note_subscribed_in_app',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>

                  </div>
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>Mobile</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_note_subscribed_in_mobile',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>
                  </div>
                </div>
              </div>
              <a-divider/>
              <div class="flex items-center">
                <div class="flex-grow">
                  <p class="font-semibold">Note updated</p>
                  <p class="text-sm text-justify md:w-2/3">
                    Notify me when a note that I am subscribed to is updated.
                  </p>
                </div>
                <div class="space-y-4">
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>in-app</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_update_note_in_app',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>

                  </div>
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>Mobile</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_update_note_in_mobile',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>

                  </div>
                </div>
              </div>
              <a-divider/>
              <div class="flex items-center">
                <div class="flex-grow">
                  <p class="font-semibold">Note deleted</p>
                  <p class="text-sm text-justify md:w-2/3">
                    Notify me when a note that I am subscribed to is deleted.
                  </p>
                </div>
                <div class="space-y-4">
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>in-app</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_delete_note_in_app',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>

                  </div>
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>Mobile</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_deleted_note_in_mobile',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>

                  </div>
                </div>
              </div>
              <a-divider/>
<!--              <div class="flex items-center">-->
<!--                <div class="flex-grow">-->
<!--                  <div class="space-x-2">-->
<!--                    <feather-icon icon="PhoneIcon" theme="filled" svg-classes="w-4 h-4" class="inline-block"/>-->
<!--                    <p class="font-bold text-lg inline-block">Phone Logs</p>-->
<!--                  </div>-->
<!--                  <p class="font-semibold">Subscribed to phone log notifications</p>-->
<!--                  <p class="text-sm text-justify md:w-2/3">-->
<!--                    Notify me when someone else subscribes me to notifications for a phone log-->
<!--                  </p>-->
<!--                </div>-->
<!--                <div class="space-y-4">-->
<!--                  <div class="flex justify-evenly items-center space-x-2">-->
<!--                    <div>in-app</div>-->
<!--                    <a-form-item>-->
<!--                      <a-switch v-decorator="['is_phone_log_subscribed_in_app',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">-->
<!--                        <a-icon slot="checkedChildren" type="check" />-->
<!--                        <a-icon slot="unCheckedChildren" type="close" />-->
<!--                      </a-switch>-->
<!--                    </a-form-item>-->

<!--                  </div>-->
<!--                  <div class="flex justify-evenly items-center space-x-2">-->
<!--                    <div>Mobile</div>-->
<!--                    <a-form-item>-->
<!--                      <a-switch v-decorator="['is_phone_log_subscribed_in_mobile',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">-->
<!--                        <a-icon slot="checkedChildren" type="check" />-->
<!--                        <a-icon slot="unCheckedChildren" type="close" />-->
<!--                      </a-switch>-->
<!--                    </a-form-item>-->

<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <a-divider/>-->
<!--              <div class="flex items-center">-->
<!--                <div class="flex-grow">-->
<!--                  <p class="font-semibold">Phone log Updated</p>-->
<!--                  <p class="text-sm text-justify md:w-2/3">-->
<!--                    Notify me when a note that I am subscribed to is deleted.-->
<!--                  </p>-->
<!--                </div>-->
<!--                <div class="space-y-4">-->
<!--                  <div class="flex justify-evenly items-center space-x-2">-->
<!--                    <div>in-app</div>-->
<!--                    <a-form-item>-->
<!--                      <a-switch v-decorator="['is_update_phone_log_in_app',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">-->
<!--                        <a-icon slot="checkedChildren" type="check" />-->
<!--                        <a-icon slot="unCheckedChildren" type="close" />-->
<!--                      </a-switch>-->
<!--                    </a-form-item>-->
<!--                  </div>-->
<!--                  <div class="flex justify-evenly items-center space-x-2">-->
<!--                    <div>Mobile</div>-->
<!--                    <a-form-item>-->
<!--                      <a-switch v-decorator="['is_update_phone_log_in_mobile',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">-->
<!--                        <a-icon slot="checkedChildren" type="check" />-->
<!--                        <a-icon slot="unCheckedChildren" type="close" />-->
<!--                      </a-switch>-->
<!--                    </a-form-item>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <a-divider/>-->
<!--              <div class="flex items-center">-->
<!--                <div class="flex-grow">-->
<!--                  <p class="font-semibold">Phone log deleted</p>-->
<!--                  <p class="text-sm text-justify md:w-2/3">-->
<!--                    Notify me when a phone log that I am subscribed to is deleted.-->
<!--                  </p>-->
<!--                </div>-->
<!--                <div class="space-y-4">-->
<!--                  <div class="flex justify-evenly items-center space-x-2">-->
<!--                    <div>in-app</div>-->
<!--                    <a-form-item>-->
<!--                      <a-switch v-decorator="['is_delete_phone_log_in_app',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">-->
<!--                        <a-icon slot="checkedChildren" type="check" />-->
<!--                        <a-icon slot="unCheckedChildren" type="close" />-->
<!--                      </a-switch>-->
<!--                    </a-form-item>-->
<!--                  </div>-->
<!--                  <div class="flex justify-evenly items-center space-x-2">-->
<!--                    <div>Mobile</div>-->
<!--                    <a-form-item>-->
<!--                      <a-switch v-decorator="['is_delete_phone_log_in_mobile',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">-->
<!--                        <a-icon slot="checkedChildren" type="check" />-->
<!--                        <a-icon slot="unCheckedChildren" type="close" />-->
<!--                      </a-switch>-->
<!--                    </a-form-item>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <a-divider/>-->
<!--              <div class="flex items-center">-->
<!--                <div class="flex-grow">-->
<!--                  <div class="space-x-2">-->
<!--                    <feather-icon icon="InboxIcon" theme="filled" svg-classes="w-4 h-4" class="inline-block"/>-->
<!--                    <p class="font-bold text-lg inline-block">Secure Message</p>-->
<!--                  </div>-->
<!--                  <p class="font-semibold">Secure message received</p>-->
<!--                  <p class="text-sm text-justify md:w-2/3">-->
<!--                    Notify me when I receive a secure message-->
<!--                    from someone else.-->
<!--                  </p>-->
<!--                </div>-->
<!--                <div class="space-y-4">-->
<!--                  <div class="flex justify-evenly items-center space-x-2">-->
<!--                    <div>Email</div>-->
<!--                    <a-form-item>-->
<!--                      <a-switch v-decorator="['is_secure_message_in_email',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">-->
<!--                        <a-icon slot="checkedChildren" type="check" />-->
<!--                        <a-icon slot="unCheckedChildren" type="close" />-->
<!--                      </a-switch>-->
<!--                    </a-form-item>-->

<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <a-divider/>-->
              <div class="flex items-center">
                <div class="flex-grow">
                  <div class="space-x-2">
                    <feather-icon icon="ListIcon" theme="filled" svg-classes="w-4 h-4" class="inline-block"/>
                    <p class="font-bold text-lg inline-block">Tasks</p>
                  </div>
                  <p class="font-semibold">Task assigned</p>
                  <p class="text-sm text-justify md:w-2/3">
                    Notify me when I am assigned a task by
                    someone else.
                  </p>
                </div>
                <div class="space-y-4">
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>Email</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_task_in_email',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>

                  </div>
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>in-app</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_task_in_app',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>

                  </div>
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>Mobile</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_task_in_mobile',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>
                  </div>
                </div>
              </div>
              <a-divider/>
              <div class="flex items-center">
                <div class="flex-grow">
                  <p class="font-semibold">Task updated </p>
                  <p class="text-sm text-justify md:w-2/3">
                    Notify me when a task that I create or am
                    assigned to is updated by someone else.
                  </p>
                </div>
                <div class="space-y-4">
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>Email</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_update_task_in_email',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>
                  </div>
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>in-app</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_update_task_in_app',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>
                  </div>
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>Mobile</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_update_task_in_mobile',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>
                  </div>
                </div>
              </div>
              <a-divider/>
              <div class="flex items-center">
                <div class="flex-grow">
                  <p class="font-semibold">Task deleted</p>
                  <p class="text-sm text-justify md:w-2/3">
                    Notify me when a task that I create or am
                    assigned to is deleted by someone else.
                  </p>
                </div>
                <div class="space-y-4">
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>Email</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_deleted_task_in_email',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>
                  </div>
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>in-app</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_deleted_task_in_app',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>
                  </div>
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>Mobile</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_mobile_task_in_mobile',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>
                  </div>
                </div>
              </div>
              <a-divider/>
              <div class="flex items-center">
                <div class="flex-grow">
                  <p class="font-semibold">Task completed</p>
                  <p class="text-sm text-justify md:w-2/3">
                    Notify me when a task that I assign to someone
                    else is completed.
                  </p>
                </div>
                <div class="space-y-4">
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>Email</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_complete_task_in_email',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>
                  </div>
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>in-app</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_complete_task_in_app',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>
                  </div>
                  <div class="flex justify-evenly items-center space-x-2">
                    <div>Mobile</div>
                    <a-form-item>
                      <a-switch v-decorator="['is_complete_task_in_mobile',{ initialValue: false,valuePropName: 'checked',rules: [{ required: false }] }]">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                      </a-switch>
                    </a-form-item>
                  </div>
                </div>
              </div>
              <a-divider/>
<!--              <div class="flex items-center">-->
<!--                <div class="flex-grow">-->
<!--                  <p class="font-semibold">Task list assigned</p>-->
<!--                  <p class="text-sm text-justify md:w-2/3">-->
<!--                    Notify me when I am assigned a task list by-->
<!--                    someone else.-->
<!--                  </p>-->
<!--                </div>-->
<!--                <div class="space-y-4">-->
<!--                  <div class="flex justify-evenly items-center space-x-2">-->
<!--                    <div>Email</div>-->
<!--                    <a-switch v-decorator="['is_complete_task_in_mobile',{ initialValue: false,rules: [{ required: false }] }]">-->
<!--                      <a-icon slot="checkedChildren" type="check" />-->
<!--                      <a-icon slot="unCheckedChildren" type="close" />-->
<!--                    </a-switch>-->
<!--                  </div>-->
<!--                  <div class="flex justify-evenly items-center space-x-2">-->
<!--                    <div>in-app</div>-->
<!--                    <a-switch default-checked>-->
<!--                      <a-icon slot="checkedChildren" type="check" />-->
<!--                      <a-icon slot="unCheckedChildren" type="close" />-->
<!--                    </a-switch>-->
<!--                  </div>-->
<!--                  <div class="flex justify-evenly items-center space-x-2">-->
<!--                    <div>Mobile</div>-->
<!--                    <a-switch default-checked>-->
<!--                      <a-icon slot="checkedChildren" type="check" />-->
<!--                      <a-icon slot="unCheckedChildren" type="close" />-->
<!--                    </a-switch>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->

<!--              <Footer class="contact-footer" url="/contacts"/>-->


              <div class="space-x-2">
                <a-button type="primary" @click="$emit('changeTab','UserSettingsNotifications')" ghost style="border-radius: 3px !important;">Cancel</a-button>
                <a-button type="primary" html-type="submit" style="border-radius: 3px !important;">Save</a-button>
              </div>


            </a-form>



          </a-card>
        </div>
    </vx-card>
</template>

<script>
import mixin from '../../../mixin/mixin'
import Footer from "@/views/footer/Footer";
import axios from '@/axios'

export default {
  name: "Notifications",
  mixins:[mixin],
  components:{
    Footer
  },
  data(){
    return{
      scrollpx: 0
    }
  },
  methods:{
    handleScroll() {
      this.scrollpx = window.scrollY;
    },
    handleNotifications(){
      this.form.validateFields(async(err,values)=>{
        if(!err){
            try{
              this.$vs.loading()
              await axios.put(`/setting/personal/`,{ notifications:values })
              this.$notification['success']({
                message: 'Success',
                description: `Notifications success.`,
              });
              this.$emit('changeTab','UserSettingsConnections')
            }catch (e) {
              this.$notification['error']({
                message: 'Failed',
                description: `Notifications failed.`,
              });
            }finally {
              this.$vs.loading.close()
            }
        }
      })
    },
    async getNotifications(){
      try{
        this.$vs.loading()
        const { data } = await axios.get(`/setting/personal/notifications/`)
        this.$nextTick(()=>this.form.setFieldsValue(data))

      }catch (e) {
        this.$message.error('Error receiving data')
      }finally {
        this.$vs.loading.close()
      }
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
    this.getNotifications()
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<style >

  .ant-card-head-wrapper{
    /*display: inline-grid !important;*/
  }

  [dir=ltr] .ant-card-extra{
    padding: 0;
    float: left;
  }
  .slide-up-enter-active {
    transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-up-leave-active {
    transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-up-enter, .slide-fade-leave-to {
    transform: translateY(10vh);
    opacity: 0;
  }

  .slide-up-enter-to, .slide-up-leave {
    max-height: 100px;
    overflow: hidden;
  }

  .slide-up-enter, .slide-up-leave-to {
    overflow: hidden;
    max-height: 0;
  }

  .save-changes{
    position: fixed;
    bottom: 0;
    z-index: 10000;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

</style>
